import React from 'react';
import { Text, StyleSheet } from 'react-native';
import Theme from '../../theme';
import { verticalScale } from 'react-native-size-matters';

const FormHeader = ({ title, style = {} }) => (
  <Text style={[styles.formHeaderStyle, style]}>
    {title}
  </Text>
);

const styles = StyleSheet.create({
  formHeaderStyle: {
    fontSize: 18,
    fontFamily: Theme.Custom900,
    textAlign: 'center',
    color: Theme.CHARCOAL,
    paddingVertical: verticalScale(10, 1),
  },
});

export default FormHeader;
